import { render, staticRenderFns } from "./print-bon-medical.html?vue&type=template&id=2230749d&scoped=true&external"
import script from "./print-bon-medical.js?vue&type=script&lang=js&external"
export * from "./print-bon-medical.js?vue&type=script&lang=js&external"
import style0 from "./print-bon-medical.scss?vue&type=style&index=0&id=2230749d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230749d",
  null
  
)

export default component.exports